import * as React from 'react'
import { accessControlContext } from './context'
import { type AccessControlHandler, type BaseRules, createAccessControlHandler } from './AccessControlHandler'

export function useAccessControl<RULES extends BaseRules>(rules: RULES): AccessControlHandler<RULES> {
  const context = React.useContext(accessControlContext)

  if (context === undefined) {
    throw new Error("Can't use useAccessControl outside of a Provider")
  }

  return React.useMemo(() => createAccessControlHandler({ ...context, rules }), [context, rules])
}
